import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./pages/App.jsx";

import "./assets/styles/styles.scss";

function mount() {
  const el = document.getElementById("ict-routes-realtime-app");
  if (!el || el.__reactRoot) return;

  el.__reactRoot = ReactDOM.createRoot(el);
  el.__reactRoot.render(
    <BrowserRouter future={{
      v7_relativeSplatPath: true,
      v7_startTransition: true,
    }}>
      <App />
    </BrowserRouter>
  );
}

/* run immediately */
mount();

/* run again after Drupal AJAX attaches */
document.addEventListener("DOMContentLoaded", mount);
